module.exports = __webpack_public_path__ + "static/3-2b67c00e993bed652f97880330a45fcc.png";